module.exports = __webpack_public_path__ + "img/44_42.724a234a.png";